/**
 * Map of BODACC family types to human-readable labels
 */
export const BODACC_FAMILY_TYPES = {
  radiation: 'Radiation',
  vente: 'Vente/Retraite',
  collective: 'Procédure collective',
  modification: 'Modification',
  creation: 'Création',
  immatriculation: 'Immatriculation',
  conciliation: 'Conciliation',
  divers: 'Divers',
  dpc: 'Dépot des comptes',
  inconnue: 'Inconnue',
  retablissement_professionnel: 'Rétablissement professionnel',
};

/**
 * Get the color class for a BODACC family type
 * @param familyType The BODACC family type
 * @returns The Tailwind CSS color class
 */
export const getBodaccColorClass = (familyType: string): string => {
  switch (familyType) {
    case 'radiation':
    case 'Radiation':
    case 'collective':
    case 'Procédure collective':
      return 'text-red-600';
    case 'vente':
    case 'Vente':
      return 'text-amber-500';
    default:
      return 'text-gray-700';
  }
};

/**
 * Get the border color class for a BODACC family type
 * @param familyType The BODACC family type
 * @returns The Tailwind CSS border color class
 */
export const getBodaccBorderColorClass = (familyType: string): string => {
  switch (familyType) {
    case 'radiation':
    case 'Radiation':
    case 'collective':
    case 'Procédure collective':
      return 'border-red-500';
    case 'vente':
    case 'Vente':
      return 'border-amber-300';
    default:
      return 'border-gray-300';
  }
};

/**
 * Format a date string to French locale format
 * @param dateString The date string to format
 * @returns The formatted date string
 */
export const formatDate = (dateString: string): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}; 